import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainPage from "./pages/mainPage";
import OpenAIPage from "./pages/openAIPage"; // Correctly import OpenAIPage

function App() {
    return (
        <Router>
            <div className="App">
                <Routes>
                    <Route path="/" element={<MainPage />} />
                    <Route path="/interview" element={<OpenAIPage />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
